const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getPlanQueryOptions } from '@/lib/queries/adaptive-planner/useGetPlanQuery';
import { getTimelineItemsDataSetQueryOptions } from '@/lib/queries/adaptive-planner/useGetTimelineItemsDataSetQuery';
import { usePlanPermissionOptions } from '@/lib/queries/adaptive-planner/usePlanPermission';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
export const Route = createFileRoute('/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(itemPanelSearchSchema),
  loader: async ({
    context: {
      queryClient
    },
    params: {
      scenarioId,
      planId
    }
  }) => {
    const planNum = Number(planId);
    const scenarioNum = Number(scenarioId);
    await queryClient.ensureQueryData(getPlanQueryOptions({
      planId: planNum
    }));
    await queryClient.ensureQueryData(getTimelineItemsDataSetQueryOptions({
      planId: planNum,
      scenarioId: scenarioNum
    }));
    await queryClient.ensureQueryData(usePlanPermissionOptions({
      planId: planNum
    }));
  },
  pendingComponent: FullSizeSpinner
});